export const HIT_PT_TEAM_MANAGEMENT = 'HIT_PT_TEAM_MANAGEMENT';
export const GET_PT_TEAM_MANAGEMENT = 'GET_PT_TEAM_MANAGEMENT';

export const HIT_PT_ADD_TEAM_MANAGEMENT = 'HIT_PT_ADD_TEAM_MANAGEMENT';

export const HIT_PT_ADD_TEAM_MEMBER = 'HIT_PT_ADD_TEAM_MEMBER';
